import { Dialog } from '../Modals/Dialog'
import { ProjectNewsCardDialog } from './CardDialog'
import type { Locales, ProjectUpdate } from '@captaincause/types'

interface DialogSingleNewsProps {
  news?: ProjectUpdate
  close: () => void
  locale: Locales
  rootNode: string
}

export function DialogSingleNews({
  news = undefined,
  close,
  locale,
  rootNode,
}: DialogSingleNewsProps) {
  return (
    <Dialog
      isOpen={!!news}
      close={close}
      panelClassName="md:w-[600px] max-h-[80vh] lg:w-[700px]"
      rootNode={rootNode}
      withCloseButton
    >
      {news ? <ProjectNewsCardDialog news={news} locale={locale} /> : null}
    </Dialog>
  )
}
